module.exports = __webpack_public_path__ + "static/how-why-sponsor-confs-cdd2e6d58a722818f454f1d072c18c4a.png";